exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h2{text-decoration:underline}.textarea:not([rows]){max-height:110px;min-height:110px}.container{margin-bottom:30px}.column>img{margin-top:60px}.button-field{display:flex;justify-content:center}#left-line{margin-top:27px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2f654662","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Order.vue
// module id = 160
// module chunks = 0